// extracted by mini-css-extract-plugin
module.exports = {"arrow-container":"styles__arrow-container___3uRRA","small":"styles__small___1tsms","arrow":"styles__arrow___39uyn","icon":"styles__icon___LdBWO"};